import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import OrderSignResult from '../../../components/order-sign-result/order-sign-result';
import AppPageMain from '../../../modules/app-page/app-page--main';
import IconBtn from '../../../modules/icon-btn/icon-btn';
import PageHeader from '../../../modules/page-header';
import { RootState } from '../../../types';

const AssetsSellingResultPage: React.FC = () => {
  const history = useHistory();
  const resultState = useSelector(
    (state: RootState) => state.signResult.saleCfa
  );

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/assets', title: 'Активы' },
                { link: '#', title: 'Денежные требования' },
              ]}
              iconType="assets"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <OrderSignResult
              loading={false}
              linkContent={
                <IconBtn
                  title="Продать цфа"
                  onClick={() => history.push('/assets/selling')}
                />
              }
              submitBtn={
                <IconBtn
                  title="Перейти в активы"
                  onClick={() => history.push('/assets')}
                />
              }
              success={!!resultState.success}
            />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default AssetsSellingResultPage;
